import React, { useCallback } from 'react';
import Clickable from '@prisjakt/ui-clickable';
import * as S from '../styles';
import { IAlternativePriceRowProps } from './types';
import StockPriceInfo from '../../components/stock-price-info';
import OptionsColumn from './options-cloumn';
import { AlternativePrice } from 'src/types';
import { GoToStoreButton } from '../../components/go-to-store-button';

const AlternativePriceRow = ({
  campaign,
  onClickOut,
  price,
  store: priceStore,
  productImage,
  tableLinkProps,
  priceDisplay,
  isInternationalPrice,
}: IAlternativePriceRowProps) => {
  const featured = priceStore && priceStore.featured;

  const handleClickOut = useCallback(
    (e: React.MouseEvent) => onClickOut(e, price.id),
    [price.id, onClickOut]
  );

  return (
    <S.AltRow featured={Boolean(featured)}>
      <OptionsColumn
        price={price}
        store={priceStore}
        productImage={productImage}
      />
      {featured && price.externalUri && (
        <S.ActionArea
          container={Clickable}
          containerProps={{
            to: price.externalUri,
            'aria-label': price.name,
            rel: tableLinkProps.rel,
            isExternal: true,
            onMouseDown: tableLinkProps.onMouseDown,
            onTouchStart: tableLinkProps.onTouchStart,
            onKeyDown: tableLinkProps.onKeyDown,
            target: tableLinkProps.target,
            onClick: handleClickOut,
          }}
        >
          <S.Content>
            <S.TopMiddleRow isAlternative featured={featured}>
              <S.ProductNameColumn>
                <S.ProductName featured={featured} isAlternative>
                  {price.name}
                </S.ProductName>
              </S.ProductNameColumn>
              <StockPriceInfo
                featured={Boolean(featured)}
                campaign={getCampaignById(price, campaign)}
                price={price.price}
                priceDisplay={priceDisplay}
                stock={price.stock}
                isMemberPrice={Boolean(price.isMemberPrice)}
                countryCode={priceStore && priceStore.countryCode}
                isInternationalPrice={isInternationalPrice}
                shipping={price.shipping}
              />
            </S.TopMiddleRow>
            <S.EndColumn featured>
              <GoToStoreButton />
            </S.EndColumn>
          </S.Content>
        </S.ActionArea>
      )}

      {(!featured || !price.externalUri) && (
        <S.Link {...tableLinkProps} onClick={handleClickOut}>
          <S.TopMiddleRow>
            <S.ProductNameColumn featured>
              <S.ProductName featured={Boolean(featured)} isAlternative>
                {price.name}
              </S.ProductName>
            </S.ProductNameColumn>
            <StockPriceInfo
              featured={Boolean(featured)}
              campaign={getCampaignById(price, campaign)}
              price={price.price}
              priceDisplay={priceDisplay}
              stock={price.stock}
              isMemberPrice={false}
              countryCode={priceStore && priceStore.countryCode}
              isInternationalPrice={isInternationalPrice}
            />
          </S.TopMiddleRow>
        </S.Link>
      )}
    </S.AltRow>
  );
};

const getCampaignById = (item: AlternativePrice, campaign: any) => {
  return campaign?.price &&
    campaign?.media &&
    campaign?.name &&
    item.id === campaign.price.id
    ? campaign
    : null;
};

export default AlternativePriceRow;
